import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VuexPersist from 'vuex-persist'
import EncryptStorage from 'encrypt-storage';
import MD5 from 'crypto-js/md5'
import { apiUrl } from '@/apiUrl';
import { generalLib } from '@/generalLib';

Vue.use(Vuex)

// ==== EncryptStorage ====
// Il modulo va a criptare i dati del session storage.
// Per funzionare settiamo stateManagementUse a true, il quale indica che poi
// lo andremo ad associare a VuexPersist, inoltre specifichiamo quale tipologia
// di storage usare, cioè il sessionStorage.
const encryptStorage = new EncryptStorage( process.env.VUE_APP_STORAGE_KEY, { storageType: 'sessionStorage', stateManagementUse : true } );

// ==== VuexPersist ====
// VuexPersist sincronizza gli elemento dello state con il local
// storage del browser per mantenere la persistenza quando si fa
// il reload della pagina.
// Viene aggiunto come plugin allo store ( vedi in fondo alla
// dichiarazione delo store )
// Preso spunto da: https://www.digitalocean.com/community/tutorials/vuejs-vuex-persist-state
const vuexLocalStorage = new VuexPersist({
  key: 'wbdata', // La chiave dove vuex-persist andrà a porre i dati nello storage

  // Se in produzione usiamo l'stanza di encrypStorage in luogo di window.localStorage
  // o window.sessionStorage per andare a criptare i dati utente con questo modulo,
  // è poi l'attributo storageType di encryptStorage che definisce dove salvare idati,
  // nel nostro caso nel session storage.
  // Se invece siamo in sviluppo usiamo il window.sessionStorage di modo tale che i dati
  // siano in chiaro e quindi possiamo debuggare più facilmente.
  // Usiamo i sessionStorage che sono autocontenuti all'interno dello stesso tab
  // se usiamo il localStorage ciò che mettiamo nella chiave è condiviso tra tutti gli
  // elementi del browser e quindi è come se la sessione utente è la stessa per tutti i tab!
  //storage: window.localStorage,
  //storage: window.sessionStorage,
  //storage: encryptStorage,
  storage : process.env.NODE_ENV === 'development' ? window.sessionStorage : encryptStorage,

  // Funzione che passa allo storage le info dello state che vogliamo conservare
  // durante tutta la sessione di lavoro.
  reducer: ( state ) => ({ token : state.token,
                           user : state.user,
                           is_logged : state.is_logged,
                           user_perms: state.user_perms,
                           customer : state.customer,
                           session_infos : state.session_infos })

  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
})

export default new Vuex.Store({
  state: {
    user: null,
    is_logged : false,
    // Array con le chiavi dei permessi di menù dell'utente. Inizialmente vuota,
    // viene valorizzata/updatata ogni volta che il componente HomeMenu ( il menù principale )
    // viene richiamato.
    user_perms : new Array(),
    // Stringa che indica se stiamo caricando la versione personalizzata di un dato customer
    customer : null,
    // Informazioni generiche da tenere in memoria solo per la durata della sessione
    session_infos : {
      // Flag che indica se in questa sessione è stato dato l'ok all'informativa delle
      // convenzioni special per non visualizzarla di nuovo se si torna sul menù
      conv_special_agreed: false,
      // Flag che indica se in questa sessione è stato dato l'ok all'informativa delle
      // condizioni di utilizzo della parte di Eurete per non visualizzarla di nuovo se
      // si torna sul menù
      eurete_cond_agreed: false,
      // Flag che indica, qualora in uso, se il popup informativo della home utente
      // è stato visionato per non farlo comparire di nuovo ogni volta che si torna alla home
      // di default mettiamo true nel senso che il popup deve vedersi. La mutation relativa lo setta
      // su false.
      show_user_info_popup: true,
      // Oggetto che deve essere valorizzato in fase di login, contiene la mappa dei colori
      // personalizzati per un dato customer per i vari componenti Vue che possono essere
      // personalizzati. NON LA RESETTIAMO IN FASE DI LOGOUT!!! Altrimenti perdiamo il
      // riferimento alla mappa dei colori di questo customer. Viene semmai sostituita
      // dalla mappa di un altro customer se lo cambiamo al login senza chiudere e riaprire
      // la pagina web.
      customer_color_map: null,
      // Id che indica se il referente aziendale sta andando a richiedere informazioni per
      // un'altra azienda da lui gestita che non sia quella di appartenenza.
      // Il valore viene settato di default durante la fase di login ( vedi sotto nelle actions dedicate),
      // con un oggetto contenente id e nome dell'azienda di appartenenza dell'utente.
      // Questo fa si che nelle chiamate sia incluso l'header Act-For, il quale indica al backend
      // nelle chiamate dedicate ai referenti aziendali, per quale azienda andare a restituire
      // le informazioni. Il referente può variare questo id da interfaccia, cambiando quindi
      // l'azienda di cui avere le info.
      // Il parametro è settato solo per utenti con un profilo da referente aziendale, per
      // gli utenti "semplici" rimane null.
      // L'aggiunta dell'header per le richieste delle sole pagine della parte relativa al
      // referente aziendale avviene nel file main.js.
      act_for: null,
      // Oggetto con le info sulle notifiche ricevute dall'utente.
      // Contiene due chiavi:
      // - status : oggetto json valorizzato con le info ottenute dalla chiamata bakend
      //            fatta dalla funzione 'aggiorna_stato_notifiche', il suo contenuto viene
      //            ripreso dalla campanella nella navbar per visualizzare se ci sono nuove
      //            notifiche. Inizialmente settiamo le varie chiavi che ci si aspetta di ricevere
      //            a zero per non far andare in errore la campanella al momento del login.
      //            In quel frangente infatti prova a leggere la variabile ricevuti_new ma
      //            se non ci fosse la variabiel inizializzata a zero andrebbe in errore.
      // - polling_id : id che rappresenta il setInterval che manda in polling la
      //                chiamata 'aggiorna_stato_notifiche' per mantenere aggiorante le info.
      //                Viene a sua volta settato dalla funzione 'attiva_polling_notifiche'
      //                nella geenralLib. La 'attiva_polling_notifiche' è richiamata al login.
      //
      notifications : { status : { inviati : 0, ricevuti : 0, ricevuti_new : 0 },
                        polling_id : null }
    }
  },
  getters : {
    /**
     * Date le info sull'utente torna una stringa con nome e cognome
     */
    user_human_name: ( state ) => {
      if ( state.user === null ) {
        return '';
      }
      return state.user.user_anag.nome + ' ' + state.user.user_anag.cognome;
    }
  },
  mutations: {
    /**
     * Setta il token di autenticazione dell'utente
     */
    set_auth_token ( state, token ) {
      state.token = token;
    },
    /***
     * Setta le informazioni dell'utente
     */
    set_user_info ( state, infos ) {
      state.user = infos;
    },
    /**
     * Setta i permessi utente per i menù
     */
    set_user_perms( state, value ){
      state.user_perms = value;
    },
    /**
     * Setta un utente come loggato.
     */
    set_user_as_logged ( state ) {
      state.is_logged = true;
    },
    /**
     * Setta il customer per la quale avere colori personalizzati
     */
    set_customer ( state, customer ) {
      state.customer = customer;
    },
    /**
     * Setta la mappa dei colori personalizzata per un dato customer
     */
    set_customer_color_map ( state, value ) {
      state.session_infos.customer_color_map = value;
    },
    /**
     * Cancella il token utente
     */
    clear_auth_token ( state ) {
      state.token = null;
    },
    /**
     * Cancella l'oggetto con le info utente i permessi di menù
     * e reimposta le eventuali info di sessione al default.
     * Stoppa inoltre il polling per le notifiche.
     */
    clear_user_infos ( state ) {
      state.user = null;
      state.user_perms = new Array();
      state.session_infos.conv_special_agreed = false;
      state.session_infos.eurete_cond_agreed = false;
      state.session_infos.show_user_info_popup = true;
      state.session_infos.act_for = null;

      // Fermiamo il polling per le notifiche e resettiamo anche
      // l'oggetto delle notifiche stesso
      clearInterval ( state.session_infos.notifications.polling_id );
      state.session_infos.notifications.status = { inviati : 0, ricevuti : 0, ricevuti_new : 0 };
      state.session_infos.notifications.polling_id = null;

    },
    /**
     * Setta il flag che indica lo stato dell'utente come non
     * loggato
     */
    set_user_as_not_logged( state ) {
      state.is_logged = false;
    },
    /**
     * Aggiorna le informazioni sul credito dell'utente.
     */
    update_credit_data ( state, credit_data ) {
      state.user.user_credito = credit_data
    },
    /**
     * Aggiorna il codice covip del fondo pensionistico dell'utente
     */
    update_covip_fondo ( state, covip ) {
      state.user.user_anag.covip_fondo = covip.toString();
    },
    /**
     * Aggiorna lo stato del flag previdenza_is_ok riguardante l'ok
     * all'informativa della previdenza integrativa.
     */
    update_previdenza_is_ok ( state, previdenza_is_ok ) {
      state.user.user_anag.previdenza_is_ok = previdenza_is_ok;
    },
    /**
     * Aggiorna l'oggetto json con lo stato delle notifiche utente.
     */
    update_notifications_status ( state, value ) {
      state.session_infos.notifications.status.inviati = value.inviati;
      state.session_infos.notifications.status.ricevuti = value.ricevuti;
      state.session_infos.notifications.status.ricevuti_new = value.ricevuti_new;
    },
    /**
     * Setta il riferimento all'oggetto setInterval che fa polling
     * sulle richieste di aggiornamento dello stato delle notifiche.
     */
    set_notifications_polling_id ( state, value ) {
      state.session_infos.notifications.polling_id = value;
    },
    /**
     * Setta lo stato del flag delle convenzioni special
     */
    set_conv_special_agreement( state, value ){
      state.session_infos.conv_special_agreed = value;
    },
    /**
     * Setta lo stato del flag delle condizioni di Eurete
     */
    set_eurete_cond_agreement( state, value ){
      state.session_infos.eurete_cond_agreed = value;
    },
    /**
     * Setta il popup informativo come visualizzato
     */
    set_info_poup_as_shown( state ){
      state.session_infos.show_user_info_popup = false;
    },
    /**
     * Setta il valore per la variabile di sessione act_for al default.
     * Cioè con id e nome azienda per cui l'utente lavora, presi direttamente
     * dallo store.
     * Viene quindi creato un oggetto con id e nome dell'azienda utente
     * del tipo:
     *      { id: 3, nome: 'AKME s.p.a.' }
     */
    set_default_act_for ( state ){
      let user_azi_nome = state.user.user_azi.nome + ' ' + state.user.user_azi.cognome;
      let user_azi_id = state.user.user_azi.id;
      state.session_infos.act_for = { id: user_azi_id, nome : user_azi_nome };
    },
    /**
     * Setta il valore di act_for con un valore passatogli.
     * Anche in questo caso deve trattarsi di un oggetto avente la forma:
     *
     *        { id: 3, nome: 'AKME s.p.a.' }
     *
     * cioè con id e nome dell'azienda.
     */
    set_act_for ( state, value ) {
      state.session_infos.act_for = value;
    }
  },
  actions: {
    /**
     * Action che segue il login dell'utente con i dati presi dal form.
     * Se il login avviene positivamente setta le informazioni utente nello
     * store tramite l'apposita mutation ed in modo analogo setta anche il
     * flag che indica che l'utente è loggato.
     *
     * Torna al chiamate una promise con i dati di risposta sia che la chiamata
     * termini correttamente o meno per poter gestire poi il da farsi.
     *
     * Per l'autenticazione devono essere passati il token di controllo usa e getta
     * ottenuto dal primo passaggio dell'autenticazione a due fattori, ed il codice otp
     * inviato all'utente via mail
     */
    login ( context, user_data ) {

      return new Promise ( ( resolve, reject ) => {

        // == STEP 1 ==
        // Prendo il token di controllo e il codice otp ed
        // invio tutto al server per il check. Se sto facendo l'sso
        // da centro paghe devo inviare anche il suo SlugName
        let post_data = { check_token : user_data.check_token, otp : user_data.otp }
        if ( Object.prototype.hasOwnProperty.call( user_data, 'sso_provider_slug' ) ){
          post_data.sso_provider_slug = user_data.sso_provider_slug;
        }

        axios.post( apiUrl.authapi.otp_verify, post_data )
        .then( (response) => {

          context.commit('set_auth_token', response.data.token );
          context.commit('set_user_as_logged');

          // == STEP 2 ==
          // Eseguo la chiamata per avere le info utente aggiuntive
          // come l'anagrafica, il profilo e le info sul credito.
          axios.get( apiUrl.authapi.get_logged_user_info )
          .then( (response) => {

            // Setto le info
            context.commit( 'set_user_info', response.data );

            // Dalle info appena settate vedo se è un referente aziendale, se si
            // setto la variabile act_for al default con le info della sua azienda
            if ( context.state.user.profile === 'ref_aziendale' ){
              context.commit( 'set_default_act_for' );
            }

            // Attivo il polling per l'archivio notifiche.
            generalLib.attiva_polling_notifiche( true );

            // Risolvo la chiamata
            resolve( null )

          })
          .catch( (error) => {
            // Se vado in errore qui chiamo il logout per pulire il flag
            // is_logged ed il token prima di tornare, altrimenti risulterei ancora
            // come loggato e con un token valido settato.
            context.dispatch( 'logout' );
            reject( error )
          });

        })
        .catch( (error) => {
          reject( error )
        });
      });
    },
    /**
     * Action che esegue il login utente tramite la funzione ricollegati,
     * cioè quando sono inviati i dati criptati dal backoffice per ricollegarsi
     * come un utente generico.
     */
    reconnect_login ( context, userdata ) {

      return new Promise ( ( resolve, reject ) => {

        // == STEP 1 ==
        // Prendo le info utente criptate e le passo alla vista
        // che per effettuare il login, la vista mi restituisce il token di
        // autenticazione dell'utente. Quindi se va tutto bene setto il token
        // e dico che l'utente è loggato così posso subito fare la
        // chiamata per avere le info utente.
        axios.post( apiUrl.authapi.backoffice_reconnection, { d : userdata } )
        .then( (response) => {
          context.commit('set_auth_token', response.data.token );
          context.commit('set_user_as_logged');

          // == STEP 2 ==
          // Sono loggato, eseguo la chiamata per avere le info utente
          // come l'anagrafica, il profilo e le info sul credito.
          axios.get( apiUrl.authapi.get_logged_user_info )
          .then( (response) => {

            // Setto le info aggiuntive
            context.commit( 'set_user_info', response.data );

            // Dalle info appena settate vedo se è un referente aziendale, se si
            // setto la variabile act_for al default con le info della sua azienda
            if ( context.state.user.profile === 'ref_aziendale' ){
              context.commit( 'set_default_act_for' );
            }

            // Attivo il polling per l'archivio notifiche.
            generalLib.attiva_polling_notifiche( true );

            // Risolvo la chiamata
            resolve( null )
          })
          .catch( (error) => {
            // Se vado in errore qui chiamo il logout per pulire il flag
            // is_logged ed il token prima di tornare altrimenti risulterei ancora
            // come loggato e con un token valido settato.
            context.dispatch( 'logout' );
            reject( error )
          });

        })
        .catch( (error) => {
          reject( error )
        });
      });
    },
    /**
     * Si tratta della action utilizzata da enti esterni per potersi collegare
     * passando semplicemente il token che hanno già avuto chiamando il servizio
     * di autenticazione.
     * La chiamata quindi setta l'utente come loggato senza richiedere alcun token
     * e viene chiamata la funzione per avere le informazioni utente.
     */
    token_login ( context, token ) {

      return new Promise ( ( resolve, reject ) => {

        // Avendo il token posso subito settarlo e porre l'utente
        // come loggato.
        context.commit('set_auth_token', token );
        context.commit('set_user_as_logged');

        // Eseguo poi la chiamata la backend per avere le info utente e se tutto è
        // ok risolvo la chiamata.
        axios.get( apiUrl.authapi.get_logged_user_info )
        .then( (response) => {

          // Setto le info
          context.commit( 'set_user_info', response.data );

          // Dalle info appena settate vedo se è un referente aziendale, se si
          // setto la variabile act_for al default con le info della sua azienda
          if ( context.state.user.profile === 'ref_aziendale' ){
            context.commit( 'set_default_act_for' );
          }

          // Attivo il polling per l'archivio notifiche.
          generalLib.attiva_polling_notifiche( true );

          // Risolvo la chiamata
          resolve( null )

        })
        .catch( (error) => {
          // Se vado in errore qui chiamo il logout per pulire il flag
          // is_logged ed il token prima di tornare altrimenti risulterei ancora
          // come loggato e con un token valido settato.
          context.dispatch( 'logout' );
          reject( error )
        });

      });
    },
    /**
     * Eseguiamo il logout. L'azione va semplicemente a pulire i dati interni
     * relativi allo user e setta il flag is_logged a false.
     */
    logout ( context ) {
      context.commit( 'clear_auth_token' );
      context.commit( 'clear_user_infos' );
      context.commit( 'set_user_as_not_logged' );
      context.commit( 'set_conv_special_agreement', false );
      //localStorage.clear();
      //localStorage.removeItem( vuexLocalStorage.key )
    }

  },
  modules: {
  },
  plugins: [vuexLocalStorage.plugin]
})
